import {
  currentDate,
  dateDifference,
} from "../../services/Util";
import "react-calendar/dist/Calendar.css";
import React, { useState, useEffect, useRef } from "react";
import {default as ReactSelect ,  components } from "react-select";
import { useSelector, useDispatch } from "react-redux";
import { getAxiosResponse } from "../../services/authApiRoutes/APImethods";
import APIUrls from "../../services/APIUrls";
import { departmentSelected } from "../../redux/reducers/SelectDropDownSlice";
import { languageSelected } from "../../redux/reducers/LanguageFilterSlice";
import { followAction } from "../../redux/reducers/FollowingSlice";
import { updateCampaignTag } from "../../redux/reducers/CampaignTagFilterSlice";
import { projectStatusSelected } from "../../redux/reducers/ProjectStatusSlice";
import { subtractMonthsToDate } from "../../services/Util";
import { useTranslation } from "react-i18next";
import { getLoggedInUserRole } from "../../services/Util";
import ReactMultiSelect from "../global/ReactMultiSelect";

import $ from "jquery";
import Constants from "../../Constants";
import { handleError } from "../../services/authApiRoutes/APImethods";
import moment from "moment";
import DateFormat from "../../pages/DateFormat";
import dateUtil, {DATE_FORMATS} from "../../services/DateUtil";
import DateRangeFilter from "./DateRangeFilter";

import { ConditionalBlock } from "../../ConditionalBlock";
export default function FilterProject(prop) {
  const { t } = useTranslation();
  const translate = t;
  const [search, setSearch] = useState('');
  const tagsRedux = useSelector((updateCampaignTag) => updateCampaignTag.campaign_tag_filter).value;
  const roleArray = getLoggedInUserRole();
  const [projectStatus, setProjectStatus] = useState("");


  const deliveryStatus = [
    { label: "", value: "" },
    { label: "Select", value: "" },
    { label: "On Track", value: "&deliveryStatus=ON_TRACK" },
    { label: "At Risk", value: "&deliveryStatus=AT_RISK" },
    { label: "Late", value: "&deliveryStatus=LATE" },
    { label: "Unknown", value: "&deliveryStatus=UNKNOWN" },
  ];

  const getPermissions = useSelector(
    (rolePermissionSelected) => rolePermissionSelected.role_permission
  ).value;
  var filterType = prop.filter;
  const [targetLanguages, setTargetLanguage] = useState([]);
  const [projectDeliveryStatus, setProjectDeliveryStatus] = useState("");

  const [selectedTags, setSelectedTag] = useState([]);
  const [tags, setTags] = useState([]);
  const dispatch = new useDispatch();
  const [departments, setDepartment] = useState([]);
  const multiSelectRef = useRef(null);
  const [departSelected, setSelectedDepartment] = useState("");
  const [langSelected, setSelectedLanguage] = useState("");
  const multiSelectRequestStatusRef = useRef(null);
  const [selectedRequestStatus, setSelectedRequestStatus] = useState([{label: translate("project_request.open"), value: "&status=OPEN"},{label: translate("project_request.accpted"), value: "&status=ACCEPTED"}]);
  const [requesterAssignedToMe, setRequesterAssignedToMe] = useState(false);
  const requestStatusOptions = [
    {label: "Check All", value: "all"},
    {label: "Uncheck All", value: "none"},
    {label: translate("project_request.open"), value: "&status=OPEN"},
    {label: translate("project_request.accpted"), value: "&status=ACCEPTED"},
    {label: translate("project_request.cancelled"), value: "&status=REJECTED"},
    {label: translate("project_request.completed"), value: "&status=CLOSED"},
  ]
  // const [monthSelected, updateMonth] = useState();
  const followedRedux = useSelector(
    (FollowingSlice) => FollowingSlice.follow
  ).value;

  const SelectDepartMent = useSelector(
    (departmentSelected) => departmentSelected.select_dropdown
  ).value;
  const SelectLanguageRedux = useSelector(
    (languageSelected) => languageSelected.selected_language
  ).value;
  const SelectProjectDeliveryStatusRedux = useSelector(
    (projectStatusSelected) => projectStatusSelected.project_status
  ).value;

  const status = [
    { label: "All", value: "" },
    { label: "Open", value: "&simpleProjectStatus=open" },
    { label: "In Creation", value: "&simpleProjectStatus=created" },
    { label: "In Quoting", value: "&simpleProjectStatus=inBidding" },
    { label: "In Translation", value: "&simpleProjectStatus=inTranslation" },
    { label: "In Review", value: "&simpleProjectStatus=inReview" },
    { label: "Completed", value: "&simpleProjectStatus=closed" },
  ];

  useEffect(() => {
    if(!roleArray.includes('ROLE_VENDOR')){
    getAxiosResponse(APIUrls.DEPARTMENT_URL)
      .then((res) => {
        if (res?.data?.code === 200) {
          var departs = res?.data?.data;
          departs.unshift({ id: "", name: translate("project_request.all_department")});
          const options = res?.data?.data?.map(({ id, name }) => ({
            label: name,
            value: id,
          }));
          setDepartment(options);
        }
      })
      .catch((err) => {
        handleError(err);
      });
    }
    if(!roleArray.includes('ROLE_VENDOR')){
    getAxiosResponse(APIUrls.WORKSPACE_TAGS).then((res) => {
      var allTags =  [];
      if (res?.data?.code === 200) {
        res?.data?.data?.result?.map((key, index) => {
          allTags.push({ label: key?.display, value: key?.display });
        });
        var sortedTags =  [...allTags].sort((a, b) => a.label > b.label ? 1 : -1,);
        setTags(sortedTags);
        setTags(current => [{
          label: translate("task_campaign.check_all"),
          value: "all",
        },{
          label: translate("task_campaign.uncheck_all"),
          value: "none",
        }, ...current]);
        
      }
    }).catch((err) => {
      handleError(err);
    });
  }
  if(!roleArray.includes('ROLE_VENDOR')){
    getAxiosResponse(APIUrls.PROJECT_LISTING_TARGET_LANGUAGES)
      .then((res) => {
        if (res.data.code === 200) {
          var langs = res?.data?.data;
          langs.unshift({ code: "", name: "", display: "ALL - Languages" });
          const options = res?.data?.data?.map(({ code, display }) => ({
            label: display,
            value: code,
          }));
          setTargetLanguage(options);
        }
      })
      .catch((err) => {
        handleError(err);
      });
    }
  }, []);


  useEffect(() => {
    setSelectedDepartment(SelectDepartMent);
    setSelectedLanguage(SelectLanguageRedux);
    setProjectDeliveryStatus(SelectProjectDeliveryStatusRedux);
    setSelectedTag(tagsRedux)
  }, [
    SelectDepartMent,
    SelectLanguageRedux,
    SelectProjectDeliveryStatusRedux,
    tagsRedux
  ]);

  const onRequestStatusChange = (value) => {
    setSelectedRequestStatus(value)
    if (prop.onRequestStatusChange) {
      prop.onRequestStatusChange(value);
    }
  }

  const handleChange = (value) => {
    localStorage.setItem("globalSearch",false);
    setTimeout(function() {
      multiSelectRef.current.focus();
    }, 2000);
    dispatch(updateCampaignTag(value));
  };
  
  
  const handleSearchChange = (value) => {
    localStorage.setItem("globalSearch",false);
    setSearch(value);
    prop.setSearchText(value);
  };

  useEffect(() => { 
    setSearch(prop.searchText);
  },[prop.searchText])

  const handleDepartmentChange = (event) => {
    localStorage.setItem("globalSearch",false);
    dispatch(departmentSelected(event.value));
  };
  const handleLanguageChange = (event) => {
    localStorage.setItem("globalSearch",false);
    dispatch(languageSelected(event.value));
  };

  const handleProjectStatusChange = (event) => {
    localStorage.setItem("globalSearch",false);
    var projectStatus = event.target.value;
    dispatch(projectStatusSelected(projectStatus));
  };
  const handleInputChange = (e) => {
    if(e.length > 0) {
      $("#selected-lang-container").addClass("display-none");
    } else {
      $("#selected-lang-container").removeClass("display-none");
    }
  }

  const handleEscFocus = (event) => {
    if(((!$(document.activeElement).attr('aria-expanded') && event.key === Constants.ESCAPE ) || (event.key === Constants.ESCAPE && event.target.ariaExpanded === 'false')))
    {
      var element = document.getElementById("filterBtn");
      var element2 = document.getElementById("activeId");
      element.classList.toggle("show-flex");
      element2.classList.toggle("active");
       $('#activeId').attr('aria-expanded', function(_, attr) {
        return attr === 'false' ? 'true' : 'false';
      });
      $("#activeId").trigger('focus')
    }
    
  }

  const selectProjectStatusRedux = useSelector(
    (projectStatusSelected) =>
      projectStatusSelected.project_status
  );


  const handleStatusChange = (event) => {
    var selectedStatus = event.value;
    setProjectStatus(selectedStatus)
    dispatch(projectStatusSelected(selectedStatus));
  };
  
  return (
    <div id="filterBtn" className={(filterType === "tasks" || filterType === "projects-request-list") ? "filter-content flex show-flex" : "filter-content flex"} projectlisting-tour="basic-filter" onKeyDown={(e) => handleEscFocus(e)}>
      <div className="filter-inline-list">
        {getPermissions.includes("DEPARTMENT_SELECTION") ? (
          <div className="department-dropdown-lg flex-center global-dropdown-block mb-0">
            <ReactSelect  
                classNamePrefix='cw'
                aria-label="Project status"
                className="global-dropdown-select"
                value={departments.filter(function (option) {
                  return option.value === departSelected;
                })}
                options={departments}
                onChange={e => handleDepartmentChange(e)}
                    
                  />
          </div>
        ) : null}
      </div>

      {(filterType === "dashboard" || filterType === "projects" ) ? (
        <DateRangeFilter showRangeDropDown = {true}/>
      ) : (
        ""
      )}

      {filterType === "dashboard" ? (
        <div className="filter-inline-list flex-center">
          <div className="drop-down flex-center global-dropdown-block mb-0">
            <ReactSelect  
                classNamePrefix='cw'
                aria-label="Project status"
                className="global-dropdown-select"
                value={targetLanguages.filter(function (option) {
                  return option.value === langSelected;
                })}
                options={targetLanguages}
                onChange={e => handleLanguageChange(e)}
                    
                  />
          </div>
        </div>
      ) : (
        ""
      )}
      {["projects","campaign", "projects-request-list"].indexOf(filterType) > -1 ? (
        <div className="filter-inline-list">
          <div className="search width-255 activity-search">
            <input
              style={{ border: "none" }}
              type="text"
              placeholder={filterType === "projects-request-list" ? translate("project_listing.project_request.request_name") : translate("project_listing.project_name")}
              id="search"
              name="search"
              className="search-control"
              value={search}
              onChange={(e) => {
                handleSearchChange(e.target.value);
              }}
            />
            <button className="submit" aria-label="search">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="18"
                viewBox="0 0 20 18"
                fill="none"
              >
                <path
                  d="M9.43839 14.25C12.9291 14.25 15.7589 11.5637 15.7589 8.25C15.7589 4.93629 12.9291 2.25 9.43839 2.25C5.94769 2.25 3.11792 4.93629 3.11792 8.25C3.11792 11.5637 5.94769 14.25 9.43839 14.25Z"
                  stroke="#88888A"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M17.3391 15.75L13.9023 12.4875"
                  stroke="#88888A"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
        </div>
      ) : (
        ""
      )}

      {getPermissions?.includes("FOLLOW") &&
      filterType !== "projects-request-list" ? (
        <div className="filter-inline-list">
          <div className="group-btn flex-center" role="tablist">
            <button
              className={
                followedRedux ? "dashboard-btn" : "active dashboard-btn"
              }
              onClick={() => {
                localStorage.setItem("globalSearch",false);
                dispatch(followAction(false));
              }}
             
              role="tab"
              aria-label={followedRedux ? translate("project_page.all") : 'Current tab ' + translate('project_page.all')}
              aria-selected={followedRedux ? "false" : "true"}
            >
              {translate("project_page.all")}
            </button>
            <button
              className={
                followedRedux ? "active dashboard-btn" : "dashboard-btn"
              }
              onClick={() => {
                localStorage.setItem("globalSearch",false);
                dispatch(followAction(true));
              }}
              role="tab"
              aria-label={followedRedux ? 'Current tab ' + translate('project_page.iam_following') : translate("project_page.iam_following")}
              aria-selected={followedRedux ? "true" : "false"}
            >
              {translate("project_page.iam_following")}
            </button>
          </div>
        </div>
      ) : null}

      {filterType === "projects" && getPermissions.includes("ADVANCED_FILTER") ? 
      <div className="filter-inline-list">
         <button
         id="advance-activeId"
         className= "active dashboard-btn"
         projectlisting-tour="advance-filter"
         onClick={() => prop.funct(false)}
       >
         {translate("project_page.advance")}
       </button></div>
       :
       null
      }

      {filterType === "campaign" ? (
        <div className="filter-inline-list">
          <div className="department-dropdown-lg drop-down flex-center global-dropdown-block mb-0">
            <ReactSelect  
            classNamePrefix='cw'
            className="global-dropdown-select "
            aria-label="Project status"
            value={status.filter(function (option) {
              return option.value === selectProjectStatusRedux?.value;
            })}
            options={status}
            onChange={e => handleStatusChange(e)}
          />
          </div>
        </div>
      ) : (
        ""
      )}

      <ConditionalBlock condition={filterType === "projects-request-list" || (filterType === "tasks" && (getPermissions.includes("TAGS")))}>
        <div className="filter-inline-list flex-center">
            <div className="drop-down flex-center global-dropdown-block global-multidropdown-check mb-0 ">
              <ReactMultiSelect
                ref={multiSelectRef}
                value={selectedTags}
                option={tags}
                callback={handleChange}
                ariaLabel={'Tags'}
                placeholder={'Select tags'}
                inputChange={handleInputChange}
                />
            </div>
          </div>
      </ConditionalBlock>
      <ConditionalBlock condition={filterType === "projects-request-list"}>
        <div className="filter-inline-list flex-center">
          <div className="drop-down flex-center global-dropdown-block global-multidropdown-check mb-0 ">
            <ReactMultiSelect
                ref={multiSelectRequestStatusRef}
                value={selectedRequestStatus}
                option={requestStatusOptions}
                callback={onRequestStatusChange}
                ariaLabel={'Request Status'}
                placeholder={'Request Status'}
                inputChange={handleInputChange}
            />
          </div>
        </div>

        <div className="filter-inline-list">
          <div className="group-btn flex-center" role="tablist">
            <button
                className={
                  requesterAssignedToMe ? "active dashboard-btn" : "dashboard-btn"
                }
                onClick={() => {
                  if(prop.onChangeAssignedTo) {
                    prop.onChangeAssignedTo({label: "Me" , value: false})
                  }
                  setRequesterAssignedToMe(true);
                }}

                role="tab"
                aria-label={translate("project_page.assigned_to_me")}
                aria-selected={requesterAssignedToMe ? "true" : "false"}
            >
              {translate("project_page.assigned_to_me")}
            </button>
            <button
                className={
                  requesterAssignedToMe ? "dashboard-btn" : "active dashboard-btn"
                }
                onClick={() => {
                  if(prop.onChangeAssignedTo) {
                    prop.onChangeAssignedTo({label: "All", value: true})
                  }
                  setRequesterAssignedToMe(false);
                }}
                role="tab"
                aria-label={translate("project_page.all")}
                aria-selected={requesterAssignedToMe ? "false" : "true"}
            >
              {translate("project_page.all")}
            </button>
          </div>
        </div>
      </ConditionalBlock>
      <ConditionalBlock condition={filterType === "tasks"}>
        <div className="filter-inline-list">
          <button id="advance-activeId" className= "active dashboard-btn" projectlisting-tour="advance-filter" onClick={() => prop.funct(false)}>
            {translate("project_page.advance")}
          </button>
        </div>
      </ConditionalBlock>
    </div>
  );
}
